import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListePointsEau = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"ListePointsEau"}/>
        </div>
    );
}
export default ListePointsEau;